// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".C5Ifjn3mP-mB6pNa43bCFw\\=\\={width:100%}", "",{"version":3,"sources":["webpack://./FrontEnd/scripts/modules/braze/elements/picture/picture.module.scss"],"names":[],"mappings":"AAAA,4BACI,UAAA","sourcesContent":[".image {\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": "C5Ifjn3mP-mB6pNa43bCFw=="
};
export default ___CSS_LOADER_EXPORT___;
